<div class="configurator__ui">
  <tools-menu class="configurator__menu" [label]="this.applicationData.configuration.currentLabel" [layer]="applicationService.currentLayerData"></tools-menu>
  <div class="configurator__canvas">
    <div class="configurator__rotation-indicator">
      <button class="round-button"><span class="round-button__icon icon icon-angle"></span></button>{{ canvasRotation }}&deg;
    </div>
    <label-canvas [command]="command" [label]="applicationData.configuration.currentLabel" [layer]="applicationService.currentLayerData" (onRotation)="updateRotation($event)"></label-canvas>
    <tools-bar class="configurator__tools" (onCommand)="onCommand($event)"  [label]="applicationData.configuration.currentLabel" [layer]="applicationService.currentLayerData"></tools-bar>
  </div>
</div>

<div class="configurator__tools">
  <manager-panel [label]="applicationData.configuration.currentLabel"></manager-panel>
  <tool-tip></tool-tip>
</div>

<app-modal id="modal-excel" width="750" [blocking]="false" #me>
  <ng-container *ngIf="(excelImportStep === 1) && (excelErrorRef == '') && (excelProgressRef == '')">
    <ul class="step step-1">
      <li (click)="me.close()" class="bottom-border">
        <span class="icon icon-text"></span>
        <span>{{'cfg_import_manually' | translate }}</span>
      </li>
      <li (click)="selectExcelMode()" class="bottom-border">
        <span class="icon icon-csv-file-format-extension"></span>
        <span>{{'cfg_import_from_excel' | translate }}</span>
      </li>
      <li class="excel-advice" (click)="clickExcelAdvice()">
        <span class="icon icon-information"></span>
        <span>{{'cfg_import_advice' | translate }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="(excelImportStep == 2) && (excelErrorRef == '') && (excelProgressRef == '')">
    <ul class="step step-2">
      <li (click)="step2openedBox = 1; step2selectedFile = -1" [class.closed]="step2openedBox == 2" class="bottom-border">
        <span class="icon icon-blank-file"></span>
        <span>{{'cfg_excel_fill_menu1_title' | translate }}<span class="text-regular">{{'cfg_excel_fill_menu1_undertitle' | translate }}</span></span>
        
        <ul class="step-subcontent">
          <li>
            <div class="userInput-container">
              <div class="step-subcontent_userInputs">
                <div class="step-subcontent_userInputs_item" *ngFor="let input of step2userInputs ; let i = index">
                  <input type="text" [(ngModel)]="step2userInputs[i].value"><i (click)="deleteUserInputs(i)">&times;</i>
                  
                </div>
              </div>
              <div class="step-subcontent_userInputs_preview">
                <table>
                  <tr>
                    <th *ngFor="let field of step2userInputs">{{ field.value }}</th>
                  </tr>
                  <tr *ngFor="let row of [1,2,3,4]">
                    <td *ngFor="let field of step2userInputs">&nbsp;</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="text-button-accent" (click)="addUserInputs()"><i class="icon-round-add-button"></i> {{ 'cfg_import_addField' | translate }}</div>
            <button class="button--square button--outline" [disabled]="step2userInputs.length == 0" (click)='generateEmptyCsv()'>
              <span>{{ 'cfg_excel_download' | translate }}</span>
            </button>
          </li>
          <li class="excel-advice" (click)="clickExcelAdvice()">
            <span class="icon icon-information"></span>
            <span>{{'cfg_import_advice' | translate }}</span>
          </li>
        </ul>
      </li>
      <li (click)="step2openedBox = 2" [class.closed]="step2openedBox == 1">
        <span class="icon icon-csv-file-format-extension"></span>
        <span>{{'cfg_excel_fill_menu2_title' | translate }}</span>
        <ul class="step-subcontent">
          <li>
            <div class="step-subcontent_list">
              <div class="step-subcontent_list_item" *ngFor="let excel of userData.excels" [class.selected]="step2selectedFile == excel.id" (click)="step2selectedFile = excel.id">
                {{ excel.name }}
              </div>
            </div>
            <button class="button--square button--outline" [disabled]="step2selectedFile < 0" (click)='selectExcelFile()'>
              <span>{{ 'cfg_excel_start_label' | translate }}</span>
            </button>
          </li>
          <li class="excel-advice" (click)="clickExcelAdvice()">
            <span class="icon icon-information"></span>
            <span>{{'cfg_import_advice' | translate }}</span>
          </li>
        </ul>
      </li>
      
    </ul>
   
  </ng-container>

  <ng-container *ngIf="(excelImportStep == 3) && (excelErrorRef == '') && (excelProgressRef == '')">
      <ul class="step step-3">
        <li class="">
          <span class="icon icon-download"></span>
          <span>{{'cfg_excel_browse_title' | translate }}</span>
          <ul class="step-subcontent">
            <li>
              <div class="wysiwyg" [innerHtml]="'cfg_excel_browse_undertitle' | translate"></div>
              <button class="button--square button--outline" (click)='browseExcelFile()'>
                <span>{{ 'btn_parcourir' | translate }}</span>
              </button>
            </li>
            <li class="excel-advice" (click)="clickExcelAdvice()">
              <span class="icon icon-information"></span>
              <span>{{'cfg_import_advice' | translate }}</span>
            </li>
          </ul>
        </li>
      </ul>
    </ng-container>

  <ng-container *ngIf="excelErrorRef != ''">
      <p [innerHtml]="excelErrorRef | translate"></p>

      <div class="modal__buttons">
        <button class="button button--square" (click)="excelErrorRef = ''">
          <span>{{ 'btn_ok' | translate }}</span>
        </button>
      </div>
   </ng-container>

   <ng-container *ngIf="excelProgressRef != ''">
      <p [innerHtml]="excelProgressRef | translate"></p>
   </ng-container>

</app-modal>